import { render, staticRenderFns } from "./city-area-select.vue?vue&type=template&id=4547afd6&scoped=true&"
import script from "./city-area-select.vue?vue&type=script&lang=js&"
export * from "./city-area-select.vue?vue&type=script&lang=js&"
import style0 from "./city-area-select.vue?vue&type=style&index=0&id=4547afd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547afd6",
  null
  
)

export default component.exports